module.exports = __webpack_public_path__ + "img/Co.c53afe31.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Co.svg
// module id = B1ou
// module chunks = 1